import useApiQuery from '../useApiQuery';
import keys from './keys';

const useGetUser = ({ disabled = false } = {}) => {
  const query = useApiQuery({
    requestUrl: '/me',
    disabled,
    queryKey: keys.me,
  });

  return {
    user: query.data,
    userError: query.error,
    isUserFetchError: query.isError,
    isUserFetchSuccess: query.isSuccess,
    isUserFetching: query.isFetching,
    isUserLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetUser;
